var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5573_72201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 9.23159V9.99826C18.3336 11.7953 17.7517 13.5438 16.6757 14.9831C15.5998 16.4224 14.0874 17.4753 12.3641 17.9848C10.6408 18.4944 8.79902 18.4332 7.11336 17.8104C5.4277 17.1877 3.98851 16.0367 3.01044 14.5291C2.03236 13.0216 1.56779 11.2383 1.68603 9.44519C1.80427 7.65206 2.49897 5.9452 3.66654 4.57915C4.8341 3.21311 6.41196 2.26108 8.16479 1.86505C9.91763 1.46902 11.7515 1.65021 13.393 2.38159M18.3346 3.33159L10.0013 11.6733L7.50131 9.17326",
    stroke: "#7A5AF8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5573_72201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.3414b3ba4fb1fa0d50f20df4d37355c2.svg";
export { ForwardRef as ReactComponent };